import { render, staticRenderFns } from "./AllCustomersTable.vue?vue&type=template&id=28a7a29e"
import script from "./AllCustomersTable.vue?vue&type=script&lang=js"
export * from "./AllCustomersTable.vue?vue&type=script&lang=js"
import style0 from "./AllCustomersTable.vue?vue&type=style&index=0&id=28a7a29e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports